/* eslint-disable react/no-multi-comp */
import React from "react"
import Img from "gatsby-image/withIEPolyfill"
import { css, logTool } from "@jsUtils"
import { CONSTANTS, URLS } from "@data"
import { Headline, GridLines, CTA } from "@shared"
import { PageSection } from "../PageSection"

// eslint-disable-next-line no-unused-vars
import Styles from "./thoughtLeadership.module.scss"

const log = logTool(false)

const { NEWS } = CONSTANTS

const NewsThumb = props => {
  const { color, story, id, ready } = props
  const { title, slug, date } = story

  // const formattedTitle =
  //   title.length <= NEWS.MAX_TITLE_LENGTH ? title : `${title.substr(0, NEWS.MAX_TITLE_LENGTH)}…`

  return (
    <div id={id} className={Styles.newsThumb}>
      <Img
        className={Styles.storyThumb}
        alt={story.thumbnail.title}
        fluid={story.thumbnail.fluid}
      />
      <div className={Styles.storyCopy}>
        <Headline size={5} className={Styles.storyTitle}>
          {title}
        </Headline>
        <div className={Styles.storyDate}>{date}</div>
        <CTA
          ready={ready}
          className={Styles.storyCTA}
          content="chevron"
          color={color}
          to={`${slug}`}
        >
          Read More
        </CTA>
      </div>
    </div>
  )
}

/**
 * Thought Leadership Section
 * @param {object} props - React props
 */
const ThoughtLeadership = props => {
  const { theme, color, stories } = props
  const [ready, setReady] = React.useState(false)

  log("Thought Leadership: Stories:", stories)

  const thumbs = stories.map(story => {
    return (
      <NewsThumb
        ready={ready}
        id={`though-leadership-thumb-${story.id}`}
        key={story.id}
        color={color}
        story={story}
      />
    )
  })

  return (
    <PageSection
      className={css(Styles.section, ready && Styles.ready)}
      theme={theme}
      ready={ready}
      onReady={() => {
        setReady(true)
      }}
    >
      <GridLines theme={theme} />
      <div className={Styles.wrapper}>
        <div className={Styles.header}>
          <Headline size={2} className={Styles.headline}>
            Revolutionary ideas start here
          </Headline>
          <CTA
            ready={ready}
            className={Styles.cta}
            content="chevron"
            color={color}
            to={URLS.THOUGHT_LEADERSHIP}
          >
            Explore More
          </CTA>
        </div>
        <div className={Styles.stories}>{thumbs}</div>
      </div>
    </PageSection>
  )
}

export default ThoughtLeadership
